import React, { useState } from 'react'
import { Billing } from './Billing';

const SetupTab = () => {
  return (
    <div className='p-2'>
      <Billing />
    </div>
  )
}




export default SetupTab